import { render, staticRenderFns } from "./SliderHome.vue?vue&type=template&id=200926bc&scoped=true&"
import script from "./SliderHome.vue?vue&type=script&lang=js&"
export * from "./SliderHome.vue?vue&type=script&lang=js&"
import style0 from "./SliderHome.vue?vue&type=style&index=0&id=200926bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200926bc",
  null
  
)

export default component.exports